export enum FieldType {
  Text = 'text',
  Input = 'text-input',
  EmailInput = 'email-input',
  Checkbox = 'checkbox',
  RadioGroup = 'radio-group',
  Select = 'select-input',
  PhoneInput = 'phone-input',
  Button = 'button',
  Spacer = 'spacer',
}

export type Text = {
  fontSize: number;
  color: string;
  value: string;
  type: FieldType.Text;
  fontWeight: number;
  name?: string;
  variables?: string[];
  asHTML?: boolean;
};

export type Input = {
  required: boolean;
  placeholder?: string;
  type: FieldType.Input;
  name?: string;
};

export type EmailInput = {
  required: boolean;
  placeholder?: string;
  type: FieldType.EmailInput;
  name?: string;
};

export type Checkbox = {
  required: boolean;
  label: string;
  defaultValue: boolean;
  type: FieldType.Checkbox;
  color: string;
  fontWeight: number;
  name?: string;
  fontSize: number;
  labelAsHTML: boolean;
};

export type RadioGroup = {
  type: FieldType.RadioGroup;
  required: boolean;
  label: string;
  defaultValue: string;
  color: string;
  fontWeight: number;
  options: string;
  row: boolean;
  name?: string;
  fontSize: number;
  labelFontSize: number;
  labelFontWeight: number;
};

export type Select = {
  type: FieldType.Select;
  required: boolean;
  placeholder: string;
  defaultValue: string;
  options: string;
  name?: string;
};

export type PhoneInput = {
  name?: string;
  type: FieldType.PhoneInput;
  required: boolean;
  defaultCountry: string;
  onlyCountries?: string;
  preferredCountries?: string;
  excludeCountries?: string;
};

export type Button = {
  type: FieldType.Button;
  size: 'small' | 'medium' | 'large';
  textColor: string;
  bgColor: string;
  text: string;
  width: 'full' | 'auto';
  name?: string;
};

export type Spacer = {
  type: FieldType.Spacer;
  size: number;
  name?: string;
};

export type Field = Text | Input | EmailInput | Checkbox | RadioGroup | Select | PhoneInput | Button | Spacer;

export type FormFields = {
  fields: Field[];
};
